<style lang="scss" scoped>
.service-item {
    color: #6b6667;
    font-weight: 400;
    font-size: 15px;
    letter-spacing: 1px;

    &:hover {
        color: #000;
        font-weight: 700;
    }
    
}

.activeClass {
    font-weight: 700;
    color: #000;
}
</style>

<template>
    <div>
        <div class="d-flex flex-column custom-dropdown-item justify-content-between mb-15" v-for="(dienst, index) in vastgoedservice" :key="index">
            <a class="d-flex service-item" :href="'/diensten/' + dienst.slug">
                <img v-if="dienst.logo" :src="dienst.logo.guid" :alt="dienst.title.rendered" />
                <p class="m-0 ml-15 service-item" :class="[activeLink === dienst.title.rendered.toLowerCase() ? 'activeClass' : '' ]">{{ dienst.title.rendered }}</p>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        vastgoedservice: {
            type: Array
        }
    },
    data() {
        return {
            activeLink: ""
        }
    },
    computed: {},
    mounted() {
        // GET PAGE URL
        var pageURL = window.location.href;
        //GET LAST SEGMENT OF URL
        var lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1);
        //REMOVE - TO COMPARE WITH DATA FROM LOOP
        if (lastURLSegment === 'makelaar-verhuur' || lastURLSegment === 'makelaar-verkoop') {
            var mystring = lastURLSegment;
            mystring = mystring.replace('-', ' ');
            this.activeLink = mystring
        }
        else {
            this.activeLink = lastURLSegment;
        }
    }
}
</script>
